export default function authHeaderWithcontent() {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user?.Token) {
    return {
      'Content-Type': 'application/json'
    };
  } else {
    return {};
  }
}